import { Routes, Route, useLocation } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import Home from "./Home";
import Layout from "./Layout";
import Mint from "./Mint";
import Collection from "./Collection";
import Socials from "./Socials";
import Test from "./Test";

function TransitionWrapper() {
  let location = useLocation();

  return (
    <TransitionGroup>
      <CSSTransition key={location.key} classNames="fade" timeout={300}>
        <Routes location={location}>
          <Route
            exact
            path="/"
            element={
              <Layout gradientEnd="#d0626b">
                <Home />
              </Layout>
            }
          />
          <Route
            exact
            path="/Mint"
            element={
              <Layout gradientEnd="#3ccf9e">
                <Mint />
              </Layout>
            }
          />
          <Route
            exact
            path="/Collection"
            element={
              <Layout gradientEnd="#d1b03b">
                <Collection />
              </Layout>
            }
          />
          <Route
            exact
            path="/Socials"
            element={
              <Layout gradientEnd="#bc33d8">
                <Socials />
              </Layout>
            }
          />
          {/*Exclude on deployment*/}
          <Route
            exact
            path="/Test"
            element={
              <Layout gradientEnd="#bc33d8">
                <Test />
              </Layout>
            }
          />

        </Routes>
      </CSSTransition>
    </TransitionGroup>
  );
}

export default TransitionWrapper;
